export default {
    af: 'Afghanistan',
    al: 'Albanië',
    dz: 'Algerije',
    as: 'Amerikaans-Samoa',
    ad: 'Andorra',
    ao: 'Angola',
    ai: 'Anguilla',
    aq: 'Antarctica',
    ag: 'Antigua en Barbuda',
    ar: 'Argentinië',
    am: 'Armenië',
    aw: 'Aruba',
    au: 'Australië',
    at: 'Oostenrijk',
    az: 'Azerbeidzjan',
    bs: "Bahama's",
    bh: 'Bahrein',
    bd: 'Bangladesh',
    bb: 'Barbados',
    by: 'Wit-Rusland',
    be: 'België',
    bz: 'Belize',
    bj: 'Benin',
    bm: 'Bermuda',
    bt: 'Bhutan',
    bo: 'Bolivië',
    ba: 'Bosnië-Herzegovina',
    bw: 'Botswana',
    bv: 'Bouvet Eiland',
    br: 'Brazilië',
    io: 'Brits Indische oceaan',
    bn: 'Brunei Darussalam',
    bg: 'Bulgarije',
    bf: 'Burkina Faso',
    bi: 'Burundi',
    kh: 'Cambodja',
    cm: 'Kameroen',
    ca: 'Canada',
    cv: 'Kaapverdië',
    ky: 'Kaaimaneilanden',
    cf: 'Centraal-Afrikaanse Republiek',
    td: 'Tsjaad',
    cl: 'Chili',
    cn: 'China',
    cx: 'Christmaseiland',
    cc: 'Cocoseilanden',
    co: 'Colombia',
    km: 'Comoren',
    cg: 'Congo, Volksrepubliek',
    cd: 'Congo, Democratische Republiek',
    ck: 'Cookeilanden',
    cr: 'Costa Rica',
    ci: 'Ivoorkust',
    hr: 'Kroatië',
    cu: 'Cuba',
    cy: 'Cyprus',
    cz: 'Tsjechië',
    dk: 'Denemarken',
    dj: 'Djibouti',
    dm: 'Dominica',
    do: 'Dominicaanse Republiek',
    ec: 'Ecuador',
    eg: 'Egypte',
    sv: 'El Salvador',
    gq: 'Equatoriaal-Guinea',
    er: 'Eritrea',
    ee: 'Estland',
    et: 'Ethiopië',
    fk: 'Falklandeilanden',
    fo: 'Faeröer',
    fj: 'Fiji',
    fi: 'Finland',
    fr: 'Frankrijk',
    gf: 'Frans-Guyana',
    pf: 'Frans-Polynesië',
    tf: 'Franse Zuidelijke Gebieden',
    ga: 'Gabon',
    gm: 'Gambia',
    ge: 'Georgië',
    de: 'Duitsland',
    gh: 'Ghana',
    gi: 'Gibraltar',
    gr: 'Griekenland',
    gl: 'Groenland',
    gd: 'Grenada',
    gp: 'Guadeloupe',
    gu: 'Guam',
    gt: 'Guatemala',
    gn: 'Guinea',
    gw: 'Guinee-Bissau',
    gy: 'Guyana',
    ht: 'Haïti',
    hm: 'Heard en McDonaldeilanden',
    va: 'Heilige Stoel',
    hn: 'Honduras',
    hk: 'Hong Kong',
    hu: 'Hongarije',
    is: 'IJsland',
    in: 'India',
    id: 'Indonesië',
    ir: 'Iran',
    iq: 'Irak',
    ie: 'Ierland',
    il: 'Israël',
    it: 'Italië',
    jm: 'Jamaica',
    jp: 'Japan',
    jo: 'Jordanië',
    kz: 'Kazachstan',
    ke: 'Kenia',
    ki: 'Kiribati',
    kp: 'Noord-Korea',
    kr: 'Zuid-Korea',
    kw: 'Koeweit',
    kg: 'Kirgizstan',
    la: 'Laos',
    lv: 'Letland',
    lb: 'Libanon',
    ls: 'Lesotho',
    lr: 'Liberia',
    ly: 'Libië',
    li: 'Liechtenstein',
    lt: 'Litouwen',
    lu: 'Luxemburg',
    mo: 'Macao',
    mg: 'Madagaskar',
    mw: 'Malawi',
    my: 'Maleisië',
    mv: 'Maldiven',
    ml: 'Mali',
    mt: 'Malta',
    mh: 'Marshalleilanden',
    mq: 'Martinique',
    mr: 'Mauritanië',
    mu: 'Mauritius',
    yt: 'Mayotte',
    mx: 'Mexico',
    fm: 'Micronesië, Federale Staten',
    md: 'Moldavië',
    mc: 'Monaco',
    mn: 'Mongolië',
    ms: 'Montserrat',
    ma: 'Marokko',
    mz: 'Mozambique',
    mm: 'Myanmar',
    na: 'Namibië',
    nr: 'Nauru',
    np: 'Nepal',
    nl: 'Nederland',
    nc: 'Nieuw-Caledonië',
    nz: 'Nieuw-Zeeland',
    ni: 'Nicaragua',
    ne: 'Niger',
    ng: 'Nigeria',
    nu: 'Niue',
    nf: 'Norfolk',
    mp: 'Noordelijke Marianen',
    mk: 'Noord-Macedonië',
    no: 'Noorwegen',
    om: 'Oman',
    pk: 'Pakistan',
    pw: 'Palau',
    ps: 'Palestina',
    pa: 'Panama',
    pg: 'Papoea-Nieuw-Guinea',
    py: 'Paraguay',
    pe: 'Peru',
    ph: 'Filipijnen',
    pn: 'Pitcairn',
    pl: 'Polen',
    pt: 'Portugal',
    pr: 'Puerto Rico',
    qa: 'Qatar',
    re: 'Réunion',
    ro: 'Roemenië',
    ru: 'Rusland',
    rw: 'Rwanda',
    sh: 'Sint-Helena',
    kn: 'Saint Kitts en Nevis',
    lc: 'Saint Lucia',
    pm: 'Saint-Pierre en Miquelon',
    vc: 'Saint Vincent en de Grenadines',
    ws: 'Samoa',
    sm: 'San Marino',
    st: 'São Tomé en Principe',
    sa: 'Saudi-Arabië',
    sn: 'Senegal',
    sc: 'Seychellen',
    sl: 'Sierra Leone',
    sg: 'Singapore',
    sk: 'Slowakije',
    si: 'Slovenië',
    sb: 'Salomonseilanden',
    so: 'Somalië',
    za: 'Zuid-Afrika',
    gs: 'Zuid-Georgia en de Zuidelijke Sandwicheilanden',
    es: 'Spanje',
    lk: 'Sri Lanka',
    sd: 'Soedan',
    sr: 'Suriname',
    sj: 'Spitsbergen en Jan Mayen',
    sz: 'Ngwane, Koninkrijk Eswatini',
    se: 'Zweden',
    ch: 'Zwitserland',
    sy: 'Syrië',
    tw: 'Taiwan',
    tj: 'Tadzjikistan',
    tz: 'Tanzania',
    th: 'Thailand',
    tl: 'Timor Leste',
    tg: 'Togo',
    tk: 'Tokelau',
    to: 'Tonga',
    tt: 'Trinidad en Tobago',
    tn: 'Tunesië',
    tr: 'Turkije',
    tm: 'Turkmenistan',
    tc: 'Turks- en Caicoseilanden',
    tv: 'Tuvalu',
    ug: 'Oeganda',
    ua: 'Oekraïne',
    ae: 'Verenigde Arabische Emiraten',
    gb: 'Groot-Brittannië',
    us: 'Verenigde Staten',
    um: 'Ver afgelegen eilandjes van de Verenigde Staten',
    uy: 'Uruguay',
    uz: 'Oezbekistan',
    vu: 'Vanuatu',
    ve: 'Venezuela',
    vn: 'Vietnam',
    vg: 'Maagdeneilanden, Britse',
    vi: 'Maagdeneilanden, Amerikaanse',
    wf: 'Wallis en Futuna',
    eh: 'Westelijke Sahara',
    ye: 'Jemen',
    zm: 'Zambia',
    zw: 'Zimbabwe',
    ax: 'Åland',
    bq: 'Bonaire, Sint Eustatius en Saba',
    cw: 'Curaçao',
    gg: 'Guernsey',
    im: 'Man Eiland',
    je: 'Jersey',
    me: 'Montenegro',
    bl: 'Saint Barthélemy',
    mf: 'Sint-Maarten (Frans deel)',
    rs: 'Servië',
    sx: 'Sint Maarten',
    ss: 'Zuid-Soedan',
    xk: 'Kosovo',
}
